import { z } from "zod";

import type { ValidationMessages } from "@citrine/utils/validation";

import type { VersionedMetadata } from "../common";
import { MAX_NAME_CHAR_LIMIT } from "../common";

export const getBranchNameSchema = ({ formatMessage }: ValidationMessages) =>
  z
    .string()
    .min(1, formatMessage({ id: "branch.new.name.error" }))
    .max(
      MAX_NAME_CHAR_LIMIT,
      formatMessage(
        { id: "branch.new.name.error.length" },
        { limit: MAX_NAME_CHAR_LIMIT },
      ),
    );

export const getBranchDataSchema = (validationMessages: ValidationMessages) =>
  z.object({
    name: getBranchNameSchema(validationMessages),
  });

export type BranchData = z.input<ReturnType<typeof getBranchDataSchema>>;

export interface Branch {
  id: string;
  data: BranchData;
  // I considered using the Readonly<> utility,
  // but annotating each field (especially when rendered red) is more obvious
  readonly metadata?: VersionedMetadata;
}

export interface BranchDataVersionUpdate {
  current: string;
  latest: string;
}

export interface PredictorVersions {
  predictor_id: string;
  predictor_version: string | number;
}

export interface BranchVersionUpdate {
  data_updates: BranchDataVersionUpdate[];
  use_predictors: PredictorVersions[];
}

export interface BranchAssetVersionUpdates {
  data_updates: BranchDataVersionUpdate[];
  predictors: PredictorVersions[];
}
